// + de paramètres possible sur https://swiperjs.com/demos et sur https://swiperjs.com/swiper-api
document.addEventListener("DOMContentLoaded", function() {

    const swiper1 = new Swiper(".diaporama", {
        
        modules: [Pagination, Autoplay],
        
        slidesPerView: 1,
        spaceBetween: 10,
        loop: false,
        speed: 2500,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        pagination: {
            el: '.diaporama-pagination',
            clickable: true
        },
    });
    
    const swiper2 = new Swiper('.widgetAuto-swiper', {
        
        modules: [Pagination, Autoplay],
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        speed: 1500,
        spaceBetween: 30,
        loop: true,
        pagination: {
            el: '.widgetAuto-pagination',
            bulletClass: 'swiper-pagination-bullet widgetAuto-bullet',
            bulletActiveClass: 'swiper-pagination-bullet-active widgetAuto-bullet--active',
            clickable: true
        },
        breakpoints: {
            576: {
                slidesPerView: 2
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 15
            },
            1024: {
              slidesPerView: 3
            },
            1200: {
              slidesPerView: 3
            },
            1440: {
              slidesPerView: 4
            },
            1920: {
              slidesPerView: 5
            }
        }
    });
    
    const swiper3 = new Swiper(".widgetActualite-swiper", {
        
        modules: [Pagination],
        
        spaceBetween: 20,
        slidesPerView: 1,
        pagination: {
            el: ".widgetActualite-pagination",
            bulletClass: 'swiper-pagination-bullet widgetActualite-bullet',
            bulletActiveClass: 'swiper-pagination-bullet-active widgetActualite-bullet--active',
            clickable: true,
        },
        breakpoints: {
            768: {
              slidesPerView: 2,
              spaceBetween: 40,
            },
            1200: {
              slidesPerView: 3,
              spaceBetween: 50,
            },
            1920: {
              slidesPerView: 3,
              spaceBetween: 50,
            }
        }
    });
    
    const swiper4 = new Swiper('.crossSelling-swiper', {
        
        modules: [Pagination],
        autoplay: {
          delay: 1500,
          disableOnInteraction: false,
        },
        spaceBetween: 30,
        loop: true,
        pagination: {
            el: '.crossSelling-pagination',
            bulletClass: 'swiper-pagination-bullet crossSelling-bullet',
            bulletActiveClass: 'swiper-pagination-bullet-active crossSelling-bullet--active',
            clickable: true
        },
        breakpoints: {
            576: {
                slidesPerView: 2
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 15
            },
            1024: {
              slidesPerView: 3
            },
            1200: {
              slidesPerView: 3
            },
            1440: {
              slidesPerView: 4
            },
            1920: {
              slidesPerView: 5
            }
        }
        
    });

    const swiper5 = new Swiper(".carrouselLivraison", {
        
        modules: [Pagination, Autoplay],
        speed: 2500,
        
        autoplay: {
          delay: 1500,
          disableOnInteraction: false,
        },
        pagination: {
            el: '.diaporama-pagination',
            clickable: true
        },
        breakpoints: {
            768: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1200: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            1440: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
            1920: {
              slidesPerView: 3,
              spaceBetween: 50,
            }
        },
    });
    
    /**
     * carrousel images fiche auto
     */
    const swiperAuto1 = new Swiper(".webAutoFiche__swiper__thumbnails", {
        
        modules: [Navigation],
        
        loop: true,
        spaceBetween: 40,
        slidesPerView: 3,
        freeMode: true,
        watchSlidesProgress: true,
        navigation: {
          nextEl: ".webAutoFiche__swiper__next",
          prevEl: ".webAutoFiche__swiper__prev",
        },
      });
    const swiperAuto2 = new Swiper(".webAutoFiche__swiper__img", {
        loop: true,
        spaceBetween: 10,

        thumbs: {
          swiper: swiperAuto1,
        },
    });
});